import { SearchExternalSearchCondition, SearchExternalResultValue } from 'app/area/case/types-store';

export const ACTION = {
  REQUEST_SEARCH_EXTERNAL_PROVIDER: 'REQUEST_SEARCH_EXTERNAL_PROVIDER',
  RECEIVE_SEARCH_EXTERNAL_PROVIDER: 'RECEIVE_SEARCH_EXTERNAL_PROVIDER',
  FAIL_SEARCH_EXTERNAL_PROVIDER: 'FAIL_SEARCH_EXTERNAL_PROVIDER',
  CLEAR_SEARCH_EXTERNAL_PROVIDER_RESULTS: 'CLEAR_SEARCH_EXTERNAL_PROVIDER_RESULTS'
};

export class RequestSearchExternalProvider {
  public type: string = ACTION.REQUEST_SEARCH_EXTERNAL_PROVIDER;

  constructor(
    public caseDraftId: number, 
    public domainId: number, 
    public searchConditions: SearchExternalSearchCondition[]) {}
}

export class ReceiveSearchExternalProvider {
  public type: string = ACTION.RECEIVE_SEARCH_EXTERNAL_PROVIDER;

  constructor(
    public caseDraftId: number,
    public domainId: number,
    public resultItems: SearchExternalResultValue[][]) {}
}

export class FailSearchExternalProvider {
  public type: string = ACTION.FAIL_SEARCH_EXTERNAL_PROVIDER;

  constructor(
    public caseDraftId: number,
    public domainId: number,
    public error: string) {}
}

export class ClearSearchExternalProviderResults {
  public type: string = ACTION.CLEAR_SEARCH_EXTERNAL_PROVIDER_RESULTS;
}
